<div class="url-wrapper text-center">
  <a target="_blank" href="{{data.href}}">{{data.text}}</a>
</div>
